class QuantityBreakUpsells extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
    this.syncCartSelection = this.syncCartSelection.bind(this);
    this.upsells = [];
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.offerInput = this.closest('.quantity-break')?.previousElementSibling;
    this.quantityBreaks = this.closest('quantity-breaks');
    this.upsells = Array.from(this.querySelectorAll('.quantity-break__upsell'));

    this.upsells.forEach((upsell) => {
      if (upsell.dataset.toggle === 'true') {
        upsell.addEventListener('click', this.handleToggle);
      }
    });
    this.quantityBreaks?.addEventListener('change', this.syncCartSelection);
    this.syncCartSelection();
  }

  disconnectedCallback() {
    this.upsells.forEach((upsell) => {
      upsell.removeEventListener('click', this.handleToggle);
    });
    this.quantityBreaks?.removeEventListener('change', this.syncCartSelection);
    this.initialized = false;
  }

  handleToggle(event) {
    const upsell = event.currentTarget;
    upsell.dataset.selected = upsell.dataset.selected === 'true' ? 'false' : 'true';
  }

  syncCartSelection() {
    const cartSelectionClass = `product-info-upsell-${this.dataset.section}`;
    const isActiveOffer = this.offerInput?.checked === true;

    this.upsells.forEach((upsell) => {
      upsell.classList.toggle(cartSelectionClass, isActiveOffer);
    });
  }
}

if (!customElements.get('quantity-break-upsells')) {
  customElements.define('quantity-break-upsells', QuantityBreakUpsells);
}
